/**
 * https://docs.aws.amazon.com/AmazonS3/latest/userguide/qfacts.html
 * 5 MiB is the minimal parts size per part, with the exception of the last part.
 */
export const DEFAULT_PART_SIZE = 5 * 1024 * 1024;

export const MAX_PARALLEL_UPLOADS = 3;
export const MAX_RETRIES = 3;
/**
 * Presigned URLs are fetched in batches to avoid stockpiling URLs that may expire
 * before use (ECS task role credentials cap presigned URL lifetime to ~60 minutes).
 * When fewer than REFILL_THRESHOLD chunks have usable URLs, we fetch the next batch.
 */
export const PRESIGNED_URL_BATCH_SIZE = 20;
export const PRESIGNED_URL_REFILL_THRESHOLD = 10;
